var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    fill: "#0095FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 19C27.9201 19 28.4802 19 28.908 18.782C29.2843 18.5903 29.5903 18.2843 29.782 17.908C30 17.4802 30 16.9201 30 15.8V15.2C30 14.0799 30 13.5198 29.782 13.092C29.5903 12.7157 29.2843 12.4097 28.908 12.218C28.4802 12 27.9201 12 26.8 12L15.2 12C14.0799 12 13.5198 12 13.092 12.218C12.7157 12.4097 12.4097 12.7157 12.218 13.092C12 13.5198 12 14.0799 12 15.2L12 15.8C12 16.9201 12 17.4802 12.218 17.908C12.4097 18.2843 12.7157 18.5903 13.092 18.782C13.5198 19 14.0799 19 15.2 19L26.8 19Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 30C27.9201 30 28.4802 30 28.908 29.782C29.2843 29.5903 29.5903 29.2843 29.782 28.908C30 28.4802 30 27.9201 30 26.8V26.2C30 25.0799 30 24.5198 29.782 24.092C29.5903 23.7157 29.2843 23.4097 28.908 23.218C28.4802 23 27.9201 23 26.8 23L15.2 23C14.0799 23 13.5198 23 13.092 23.218C12.7157 23.4097 12.4097 23.7157 12.218 24.092C12 24.5198 12 25.0799 12 26.2L12 26.8C12 27.9201 12 28.4802 12.218 28.908C12.4097 29.2843 12.7157 29.5903 13.092 29.782C13.5198 30 14.0799 30 15.2 30H26.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsActive);
export default __webpack_public_path__ + "static/media/viewsActive.7a778a22c9fb4345af8cc829b6df2884.svg";
export { ForwardRef as ReactComponent };